// extracted by mini-css-extract-plugin
module.exports = {"container":"about-module--container--9b9hf","blockquoteIntro":"about-module--blockquote-intro--3p6bw"};